import Details from './details.controller';

export default Details;
